export default function(h, row, index) {
    if (row.company_main_id)
        return <span class="alert-danger">{row.login}</span>
    else
        return <span>{row.login}</span>
}
